export default __webpack_public_path__ + "static/media/Groupe 167.6a88536b.svg";